<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="disabled ? '详情' : form.pkid ? '编辑' : '新建'"
        class="adaptationModal"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :disabled="hasAuth()"
          :model="form"
          :rules="ruleValidate"
          class="form"
          label-width="110px">
        <el-row>
          <el-col :span="24">
            <el-form-item v-if="form.pkid" label="任务编号">
              <el-input v-model="form.taskNo" disabled placeholder="系统自动生成"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="任务名称" prop="taskName">
              <el-input v-model.trim="form.taskName" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="任务类型" prop="taskTypeValue">
              <el-select v-model="form.taskTypeValue" placeholder="请选择" @change="taskTypeChange">
                <el-option
                    v-for="item in taskTypes"
                    :key="item.itemID"
                    :label="item.itemName"
                    :value="item.itemValue"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属项目" prop="projectId">
              <el-input v-model="form.projectName" placeholder="请选择" readonly>
                <el-button slot="append" icon="el-icon-search" @click="$refs.selectProgram.open()"/>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="负责人" prop="leaderId">
              <el-select v-model="form.leaderId" filterable placeholder="请选择">
                <el-option
                    v-for="item in projectTeams"
                    :key="item.memberId"
                    :label="`${item.userName}(${item.userType})`"
                    :value="item.memberId"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="任务描述" prop="taskDesc">
              <el-input v-model="form.taskDesc" type="textarea" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划开始日期" prop="planBeginDate">
              <el-date-picker
                  v-model="form.planBeginDate"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  type="date"
                  placeholder="选择日期"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划完成日期" prop="planFinishDate">
              <el-date-picker
                  v-model="form.planFinishDate"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  type="date"
                  placeholder="选择日期"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="任务状态" prop="status">
              <el-radio-group v-model="form.status">
                <el-radio v-for="item in constant.toSelect(constant.taskStatus)" :key="item.value" :label="item.value">
                  {{item.label}}
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际开始日期" prop="beginDate">
              <el-date-picker
                  v-model="form.beginDate"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  type="date"
                  placeholder="选择日期"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实际完成日期" prop="finishDate">
              <el-date-picker
                  v-model="form.finishDate"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  type="date"
                  placeholder="选择日期"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-form
          ref="form2"
          :disabled="form.projectManagerId !== currentUserId"
          v-loading="contentLoading"
          :model="form"
          class="form"
          label-width="110px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="要求完成日期">
              <el-date-picker
                  v-model="form.requireFinishDate"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                  type="date"
                  placeholder="选择日期"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider content-position="left">任务附件</el-divider>
      <div>
        <el-upload
            v-if="!disabled"
            action=""
            multiple
            :http-request="submitUpload"
            :show-file-list="false">
          <el-button type="primary" :loading="uploadLoading">上传</el-button>
        </el-upload>
        <el-table border :data="form.attachments" style="margin-top: 15px;">
          <el-table-column prop="fileName" label="附件描述"/>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope">
              <el-button type="info" @click="downLoad(scope.row.filePath)">下载</el-button>
              <el-button
                  :disabled="disabled"
                  type="danger"
                  @click="form.attachments.splice(scope.$index, 1)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-divider content-position="left">任务进度</el-divider>
      <div>
        <el-button v-if="!disabled" type="primary" @click="addTaskLog">添加</el-button>
        <el-table border :data="form.taskLogs" style="margin-top: 15px;">
          <el-table-column prop="taskLog" label="工作描述">
            <template slot-scope="scope">
              <el-input
                  v-model.trim="scope.row.taskLog"
                  :disabled="disabled"
                  autosize
                  type="textarea"
                  placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="finishQuantity" label="完成百分比(%)" align="center" width="120">
            <template slot-scope="scope">
              <el-input
                  v-model.trim="scope.row.finishQuantity"
                  :disabled="disabled"
                  class="inputCenter"
                  type="number"
                  min="0"
                  max="100"
                  placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="creatorName" align="center" label="创建人" width="120"/>
          <el-table-column prop="createdTime" align="center" label="创建时间" width="140"/>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <el-button
                  :disabled="disabled || currentUserId !== scope.row.creatorId"
                  type="danger"
                  @click="form.taskLogs.splice(scope.$index, 1)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button v-if="!disabled" :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
    <program-select ref="selectProgram" @select="onSelectProgram"/>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  import ProgramSelect from "@/views/projectManage/program/ProgramSelect";
  import auth from "@/util/loginUtil";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "TaskEdit",
    components: {ProgramSelect},
    data() {
      var validatePlanBeginDate = (rule, value, callback) => {
        if (!value) {
          callback(new Error("请选择计划开始日期"));
        } else if (this.form.planFinishDate) {
          if (this.form.planFinishDate < value) {
            callback(new Error("请选择有效的日期范围"));
          } else {
            callback();
          }
        }
      };
      var validatePlanFinishDate = (rule, value, callback) => {
        if (!value) {
          callback(new Error("请选择计划完成日期"));
        } else if (this.form.planBeginDate) {
          if (value < this.form.planBeginDate) {
            callback(new Error("请选择有效的日期范围"));
          } else {
            callback();
          }
        }
      };
      var validateBeginDate = (rule, value, callback) => {
        if ([2, 3, 4, 5].includes(this.form.status)) {
          if (!value) {
            callback(new Error("请选择实际开始日期"));
          } else if (this.form.finishDate) {
            if (this.form.finishDate < value) {
              callback(new Error("请选择有效的日期范围"));
            } else {
              callback();
            }
          } else {
            callback();
          }
        } else {
          callback();
        }
      };
      var validateFinishDate = (rule, value, callback) => {
        if ([3, 4, 5].includes(this.form.status)) {
          if (!value) {
            callback(new Error("请选择实际完成日期"));
          } else if (this.form.beginDate) {
            if (value < this.form.beginDate) {
              callback(new Error("请选择有效的日期范围"));
            } else {
              callback();
            }
          }
        } else {
          callback();
        }
      };

      return {
        authName: auth.getUserName(),
        constant,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        uploadLoading: false,
        projectTeams: [],
        currentUserId: auth.getUserId(),
        currentUserName: auth.getName(),
        disabled: false,
        form: {
          pkid: 0,
          projectId: "",
          projectManagerId: "",
          projectName: "",
          taskName: "",
          leaderId: "",
          leader: "",
          taskDesc: "",
          planBeginDate: "",
          planFinishDate: "",
          beginDate: "",
          finishDate: "",
          requireFinishDate: "",
          status: 1,
          taskLogs: [],
          creatorId: "",
          attachments: [],
          taskTypeValue: "",
          taskTypeName: "",
        },
        taskTypes: [],
        ruleValidate: {
          projectId: [{required: true, message: "请选择所属项目", trigger: "change"}],
          taskName: [{required: true, message: "请输入任务名称", trigger: "blur"}],
          leaderId: [{required: true, message: "请选择负责人", trigger: "change"}],
          taskTypeValue: [{required: true, message: "请选择任务类型", trigger: "change"}],
          taskDesc: [{required: true, message: "请输入任务描述", trigger: "blur"}],
          planBeginDate: [{validator: validatePlanBeginDate, required: true, trigger: "change"}],
          planFinishDate: [{validator: validatePlanFinishDate, trigger: "change", required: true}],
          beginDate: [{validator: validateBeginDate, trigger: "change"}],
          finishDate: [{validator: validateFinishDate, trigger: "change"}],
          status: [{required: true, message: "请选择任务状态", trigger: "change"}],
        },
      };
    },
    methods: {
      open(pkid, disabled) {
        this.form.pkid = pkid;
        this.disabled = disabled;
        this.dialogVisible = true;
        this.getTaskTypeList();
        if (pkid) {
          this.getData();
        }
      },

      hasAuth() {
        if (this.disabled) {
          return true;
        }
        if (this.form.pkid === 0) {
          return false;
        } else if (this.authName === "admin") {
          return false;
        } else if ([this.form.creatorId, this.form.leaderId].includes(this.currentUserId)) {
          return false;
        } else {
          return true;
        }
      },

      // 获取任务类型列表
      getTaskTypeList() {
        this.$http.get("basic", "systemItems/selectByItemType/taskType").then(res => {
          console.log(res);
          this.taskTypes = res;
        });
      },

      // 选择任务类型
      taskTypeChange(e) {
        const taskTypeItem = this.taskTypes.find(item => item.itemValue === e);
        if (taskTypeItem) {
          this.form.taskTypeName = taskTypeItem.itemName;
        }
      },

      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
            .post("basic", "file/batch/0", formData)
            .then((res) => {
              this.uploadLoading = false;
              const fileInfo = res.data.attachments[0];
              this.form.attachments.push({
                fileName: fileInfo.fileName,
                filePath: "/attached/file/" + fileInfo.filePath,
                note: "",
              });
              this.$message.success("上传成功");
            })
            .catch(() => {
              this.uploadLoading = false;
              this.$message.error("上传失败");
            });
      },

      getData() {
        this.contentLoading = true;
        this.$http.get("basic", `tasks/${this.form.pkid}`).then(resp => {
          this.form = resp;
          this.getProjectTeam();
        }).catch(() => {
          this.contentLoading = false;
        });
      },

      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.form.taskLogs = this.form.taskLogs.filter(item => item.taskLog && item.finishQuantity);
            this.$http
                .save("basic", "tasks", this.form)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },

      onSelectProgram(row) {
        this.form.projectId = row.pkid;
        this.form.projectName = row.projectName;
        this.form.planBeginDate = this.getFormatDate(new Date());
        this.form.planFinishDate = "";
        this.getProjectTeam();
      },
      getFormatDate(date) {
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate;
      },
      getProjectTeam() {
        this.$http.get("basic", `projects/getProjectTeams/${this.form.projectId}`).then(res => {
          this.projectTeams = res;
          this.contentLoading = false;
        }).catch(() => {
          this.contentLoading = false;
        });
      },

      addTaskLog() {
        this.form.taskLogs.unshift({
          taskLog: "",
          finishQuantity: "",
          creatorId: this.currentUserId,
        });
      },

      downLoad(filePath) {
        window.open("http://emes.stepelectric.com" + filePath);
      },
    },
  };
</script>
